import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat.js"
import { mapValues } from "lodash-es"

import configJson from "./config.json" with { type: "json" }

dayjs.extend(customParseFormat)

const data = {
  ...configJson,
  hours: mapValues(configJson.hours, (times) =>
    times
      ? times.map((time) => ({
          start_time: dayjs(time[0], "HH:mm").toDate(),
          end_time: dayjs(time[1], "HH:mm").toDate(),
        }))
      : null
  ),
}

export default data
